import { apiClient } from "./api-client";
import type {
  ReportListItem,
  ReportListItemCreateRequest,
  ReportListItemUpdateMutationRequest,
} from "@/types/report-list";

const BASE_PATH = "/ReportingInterface";

export const reportListItemApi = {
  async getReportListItemsByListKey(
    reportListKey: string,
  ): Promise<ReportListItem[]> {
    return apiClient.get(
      `${BASE_PATH}/GetReportListItemsByListKey/${reportListKey}`,
    );
  },

  async getReportListItemByKey(
    reportListItemKey: string,
  ): Promise<ReportListItem> {
    return apiClient.get(
      `${BASE_PATH}/GetReportListItemByKey/${reportListItemKey}`,
    );
  },

  async createReportListItem(
    request: ReportListItemCreateRequest,
  ): Promise<{ reportListItemKey: string }> {
    return apiClient.post(`${BASE_PATH}/CreateReportListItem`, request);
  },

  async createMultipleReportListItems(
    requests: ReportListItemCreateRequest[],
  ): Promise<{ count: number }> {
    return apiClient.post(
      `${BASE_PATH}/CreateMultipleReportListItems`,
      requests,
    );
  },

  async updateReportListItem(
    request: ReportListItemUpdateMutationRequest,
  ): Promise<void> {
    // Strip client-only optimistic update fields before sending to API
    const { _optimisticParameters: _, _reportPath: __, ...apiRequest } = request;
    return apiClient.put(`${BASE_PATH}/UpdateReportListItem`, apiRequest);
  },

  async deleteReportListItem(reportListItemKey: string): Promise<void> {
    return apiClient.delete(
      `${BASE_PATH}/DeleteReportListItemByKey/${reportListItemKey}`,
    );
  },

  async deleteMultipleReportListItems(
    reportListItemKeys: string[],
  ): Promise<void> {
    return apiClient.delete(`${BASE_PATH}/DeleteMultipleReportListItems`, {
      data: reportListItemKeys,
    });
  },
};
